<template>
<div >
    <div >
        <h2 class="text-center">Welcome to Tickets Dashboard</h2>
    </div>
     
    <div >
        <div class="col-sm-3 col-sm-offset-1" >
                <div class="filters">
                    <h5><i class="fa fa-cog" /> Filters and Preferences</h5>
                    <hr>
                    <!--<div class="checkbox">
                        <label class="small"><input type="checkbox" v-model="searchData.HideAssigned">Hide Assigned Tickets</label>
                    </div>-->
                    <div class="checkbox">
                        <label class="small"><input type="checkbox" v-model="searchData.HideOpen">Hide Open Tickets</label>
                    </div>
                    <div class="checkbox">
                        <label class="small"><input type="checkbox" v-model="searchData.HideResolved">Hide Resolved Tickets</label>
                    </div>
                    
                    
                </div>
        </div>
        <div class="col-sm-7">
           
            <div class="col-sm-12">
                <div class="input-group col-md-12">
                    <input type="text" v-model="searchData.SearchText" class="form-control input-lg" placeholder="Search Ticket No or Email address" />
                    <span class="input-group-addon">
                       <span class="fa fa-search"></span>
                    </span>
                    
                </div>
                <br>
            </div>
            
            <div class="col-sm-12"  v-if="ticketsListComp.length>0" v-for="(ticket, index) in ticketsListComp">
                <div class="sitterListbox card">
                    <div class="profile-body ">
                        <div class="bottom-row">
                            <div class="content col-sm-4">
                                     <h5> Ticket Status</h5>
                                <div class="form-group">
                            <div class='form-group '>
                                <select required v-if="ticketStatusList" name="ticketStatusList" class="form-control " v-model="ticket.StatusCode">
                                  <option value="null" disabled selected hidden>Select ticket state</option>
                                  <option v-for="ticket in ticketStatusList" v-bind:value="ticket.StatusCode">
                                    {{ticket.StatusName}}
                                  </option>
                                </select>
                         
                            </div>
                            
                        </div>

                             <p>Email: <strong>{{ticket.Email}}</strong></p>
                             <p>Role: <strong>{{ticket.Role}}</strong></p>
                            <p>Submitted Date: <strong>{{dateFormatter(ticket.CreatedDate)}}</strong></p>
                              
                                
                            </div>
                            <div class="content col-sm-8">
                            <h5 >Ticket Number <strong>{{ticket.TicketNo}}</strong></h5>
                                <p class="small"> Description: {{ticket.Description}} </p> 
                            
                                <p class="small"> Remarks</p>
                                <textarea class="form-control" rows="3" v-model="ticket.Remarks"></textarea>
                                
                            </div>
                        </div>
                        <br>
                    <div class="bottom-row pull-right">
                        <button style="margin:3px;" @click="saveTicket(ticket)" class="btn btn-success btn-sm ">Save Ticket Status</button>
                        
                    </div>
                    </div>
                </div>
                </br>
            </div>
        <div class="col-sm-12" v-if="ticketsListComp.length==0">
                    <div class="sitterListbox card"><p><i class="fa fa-check"/> Goodsy, no results match your search :)</p></div>
                </div>  
         
         
        </div>
        
    </div>
</div>
</template>
<script>
 


import auth from '../../auth/index'
import store from '../../data/store'
import commonApi from '../../services/commonApi'
import customerApi from '../../services/customerApi'


export default {
 data() {
    return {
      error: '',
      ticketsList: '',
      alert: '',
      ticketStatusList: [{
          StatusCode: 0,
          StatusName: 'Open'
      },
      {
          StatusCode: 1,
          StatusName: 'Assigned'
      },
      {
          StatusCode: 2,
          StatusName: 'Resolved'
      }]
      ,
      searchData: {
          SearchText: '',
          HideAssigned: false,
          HideOpen: false,
          HideResolved: true,
      },
      emailConfirmed: true,
      title: "Dupaws Tickets Control",
      pending: true
    }
  },
  updated: function(){
      $('[data-toggle="popover"]').popover();
  
        // $zopim(function (){
        //     $zopim.livechat.hideAll();
            
        // });

        
        if (this.userRoleComp!="Admin"){
            this.$router.push({path: '/404'})
            return;
        }
  },
  mounted: function () {

    if (sessionStorage.getItem('TicketSearchText')!=null)
         {
             this.searchData.SearchText = sessionStorage.getItem('TicketSearchText')
        }
    
        if (sessionStorage.getItem('HideOpen')!=null)
         {
            if (sessionStorage.getItem('HideOpen')=="true")
                this.searchData.HideOpen = true
            else 
                this.searchData.HideOpen = false
        }
    



    if (sessionStorage.getItem('HideResolved')!=null)
         {
            if (sessionStorage.getItem('HideResolved')=="true")
                this.searchData.HideResolved = true
            else 
                this.searchData.HideResolved = false
        }
    

    if (sessionStorage.getItem('HideAssigned')!=null)
        {
            if (sessionStorage.getItem('HideAssigned')=="true")
                this.searchData.HideAssigned = true
            else 
                this.searchData.HideAssigned = false
        }


    
    this.$forceUpdate();
    this.getFilteredTickets()


    // $zopim(function (){
    //     $zopim.livechat.hideAll();
        
    // });


    // commonApi.getbookingsList(store.getters.QueryData)  //get sitters data
   

    
  },
  methods: {
       dateFormatter: function(date){
            return moment(date).format('DD MMM YYYY HH:MM')
    },
    viewBooking: function(booking){
        this.$router.push({path:'/view-admin-reservation/' + booking.ReservationId})
    },
    saveTicket(ticket){
         var self = this
        $.ajax("https://www.dupaws.com/services/api/admin/saveTicket/",  {
                type: 'POST',
                beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                },
                data: JSON.stringify(ticket),
                dataType:"json",
                contentType: "application/json; charset=utf-8",
                crossDomain: true,
                success: function (data) {
                    swal("","Ticket saved","success")
                },
                error: function () {
                }
            }); 

    },
    getFilteredTickets(){
        var self = this
        $.ajax("https://www.dupaws.com/services/api/admin/getFilteredTickets/",  {
                type: 'POST',
                beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                },
                data: JSON.stringify(self.searchData),
                dataType:"json",
                contentType: "application/json; charset=utf-8",
                crossDomain: true,
                success: function (data) {
                    self.ticketsList = data
                },
                error: function () {
                }
            }); 
    },
   
  },   
  watch:{
      'searchData.HideAssigned': function(){
            sessionStorage.setItem('HideAssigned', this.searchData.HideAssigned)
        this.getFilteredTickets()
      },
      'searchData.SearchText': function(){
            sessionStorage.setItem('TicketSearchText', this.searchData.SearchText)
        this.getFilteredTickets()
      },
      'searchData.HideResolved': function(){
          sessionStorage.setItem('HideResolved', this.searchData.HideResolved)
        this.getFilteredTickets()
      },
      'searchData.HideOpen': function(){
          sessionStorage.setItem('HideOpen', this.searchData.HideOpen)
        this.getFilteredTickets()
      }
      
   },
   head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function () {
      return {
        inner: this.title
      }
    }
  },
  computed: {
    errorMsg: function () {
      return this.error
    },
    alertMsg: function () {
      return this.alert
    },
    userRoleComp: function(){
       return store.getters.userRole
     },
     ticketsListComp: function(){
         return this.ticketsList
     }
    
  },
  
  
}

 
</script>
<style scoped>

.filters{
    padding: 10px;
    border: 1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
}

.confirmed{
    font-weight: 700;
    color: green;
}

.reviews {
    margin-bottom: 0px;
    vertical-align: bottom;
    font-size: medium;
    margin-left: 0px;

}


.align-right {
  margin-left: auto;
}

.sitterListbox {
  display:flex;
  padding: 10px;
  flex-wrap: wrap;
  
}

.bottom-row {
  display: flex;
  justify-content: space-between
}

.sitterListbox .profile-img {
  height:75px;
  width:75px;
}

.sitterListbox .profile-body {
  flex: 3;
  padding-left: 10px;
  flex-wrap:wrap;
  
  
  
}

.sitterListbox .profile-body .profile-body-details{
  display:flex;
  flex-wrap: nowrap;
}

.sitterListbox .profile-body .profile-body-aboutme {
  display: flex;
  
}

.homewrapper{
    
    display: flex;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);
    background-color: aliceblue;
    transition: 0.3s;
    border-radius: 8px;
    border-bottom-width: inherit;
}

.home-icons {
  padding:3px;
}

.sitterListbox .profile-body h2 {
  margin-top:0px;
  margin-bottom:0px;
}

.sitterListbox .profile-price {
  flex: 1;
  
}

.inline {
  display: inline;
  vertical-align: middle;
  padding-right: 1px;
  
}


.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #ffffff;
    opacity: 1;
}


.fa-heart-o {
  color:#848484; opacity: 0.7;
}


.favorite {
    color:#af1818; opacity: 0.7;
    padding-left:10px;
    
}

.favorite:hover {
    opacity: 1;
}

.favorite:active {
    
    transform: scale(1.1);
}

.card {
    /* Add shadows to create the "card" effect */
    
    transition: 0.3s;
    border:1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    
    
}



/* On mouse-over, add a deeper shadow */
.card:hover {
    box-shadow: 0 10px 16px 0 rgba(1,0,0,0.2);
    background:  aliceblue;
    opacity: 1;
    
}
    
/* Add some padding inside the card container */


</style>


// WEBPACK FOOTER //
// TicketsDashboard.vue?1a1f3f29